<template>
  <div class="about-wrapper">

    <div class="about">

      <button class="close-button" type="button" @click="closed">

        <svg fill="#fefefe" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
             x="0px" y="0px" viewBox="0 0 96 96"
             enable-background="new 0 0 96 96" xml:space="preserve">

          <polygon points="96,14 82,0 48,34 14,0
                   0,14 34,48 0,82 14,96 48,62 82,96 96,82 62,48">
          </polygon>

        </svg>

      </button>

      <div class="inner-wrapper">

        <div class="section1">

          <div class="logo-wrapper">

            <div class="logo" :style="{ backgroundImage: `url(${logo})` }" ></div>

          </div>

          <p class="title">와인포인트</p>

          <p class="subtitle">데이터어드민</p>

        </div>

        <div class="line"></div>

        <div class="section2">

          <p class="title">{{ Package.version }}</p>

          <div class="container">
            <p class="subtitle">진재권</p>
            <!-- <p class="subtitle">이동욱</p>
            <p class="subtitle">우태균</p>
            <p class="subtitle">마광휘</p>
            <p class="subtitle">신동주</p> -->
          </div>

          <p class="conclusion">...</p>

        </div>

      </div>

    </div>

  </div>
</template>

<script>
import Logo from '@/assets/images/logo.svg';
import Package from '../../../../../../package.json';

export default {
  name: 'ModalAbout',
  props: {
    param: Object,
  },
  methods: {
    closed() {
      this.$modal.clearComponent();
    },
  },
  data() {
    return {
      logo: Logo,
      Package,
    };
  },
};
</script>


<style lang="scss" scoped>
  .about-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-content: center;
    align-items: center;

    width: 100vw;
    height: 100vh;

    background-color: rgba(0, 0, 0, 0.2);

    .about {
      position: relative;

      display: flex;
      flex-direction: column;

      width: 500px;
      height: 300px;

      background-color: rgb(37, 42, 57);

      border-radius: 15px;

      .close-button {
        position: absolute;
        right: 2px;
        top: 2px;

        width: 36px;
        height: 36px;

        border: none;
        outline: none;
        background: transparent;
      }

      .inner-wrapper {
        display: flex;

        flex-direction: row;
        justify-content: center;
        align-content: center;
        align-items: center;

        width: 100%;
        height: 100%;

        .section1 {
          display: flex;
          justify-content: center;
          align-content: center;
          align-items: center;
          flex-direction: column;

          width: 160px;

          .logo-wrapper {
            display: flex;
            justify-content: center;
            align-content: center;
            align-items: center;

            width: 130px;
            height: 130px;

            background-color: rgb(240, 240, 240);
            border-radius: 130px;

            .logo {
              width: 100px;
              height: 100px;

              background-size: contain;
              background-repeat: no-repeat;
              background-position: center;
            }
          }

          .title, .subtitle {
            margin: 0;
          }

          .title {
            color: rgba(250, 250, 250, 0.9);

            margin-top: 15px;
            font-size: 18px;
          }

          .subtitle {
            color: rgba(250, 250, 250, 0.6);

            font-size: 16px;
            text-align: left;
          }
        }

        .line {
          width: 1px;
          height: 70%;

          margin-left: 30px;
          margin-right: 30px;

          background-color: rgba(250, 250, 250, 0.8);
        }

        .section2 {
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-content: center;

          width: 160px;
          height: 70%;

          .title {
            color: rgba(250, 250, 250, 0.9);
            margin: 0;
            font-size: 18px;
          }

          .container {
            margin-top: 40px;

            .subtitle {
              color: rgba(250, 250, 250, 0.6);
              margin: 0;
              font-size: 16px;
            }
          }

          .conclusion {
            color: rgba(250, 250, 250, 0.9);
            margin: 30px 0 0;
            font-size: 12px;
          }
        }
      }
    }
  }

  @media screen and (max-width: 1024px) {
    .about-wrapper {
      .about {
        width: 80%;
        height: 450px;

        .inner-wrapper {
          flex-direction: column;

          .section1 {
            margin-bottom: 50px;
            position: relative;
            padding-top: 100px;

            .logo-wrapper {
              position: absolute;
              top: -50px;
            }
          }

          .line {
            display: none;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/spa/components/modal/board-modal/ModalAbout.vue